import { daysFormat, formatDate } from 'utils/timeAndDate';

export const mapDataForBackend = (subscription) => ({
  productId: subscription.productId,
  activationDate: formatDate(subscription.activationDate, daysFormat),
});
